import script from "./OtherPodcasts.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherPodcasts.vue?vue&type=script&setup=true&lang=js"

import "./OtherPodcasts.vue?vue&type=style&index=0&id=13993b76&lang=scss"

const __exports__ = script;

export default __exports__